import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IPermission } from "@/models";
import { ToastHelper } from "@/helpers/ToastHelper";

@Component({
    name: "navbar",
})

export default class NavBar extends Vue {
    @Prop({ required: true, type: String })
    public title: string;

    @Prop({ required: false, type: String })
    public iconRoutePath: string;

    public get permission(): IPermission {
        return this.$store.state.user.permission;
    }

    public toggleFullScreen(): void {
        this.$store.dispatch("app/toggleFullScreen");
    }

    public async synchronizeWorkOrders(): Promise<void> {
        if (this.permission.manageMachinist) {
            await this.$store.dispatch("productionLines/synchronizeWorkOrders");
            ToastHelper.workOrders.toastSynchronizeWorkOrders();
        }
    }
}
